import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { marked } from "marked";
import { useDispatch, useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import Modal from "nlib/ui/Modal";
import React, { useCallback } from "react";
import UiActions from "actions/UiActions";
import classNames from "classnames";
import purify from "dompurify";

const AppModal = (props) => {
  const {
    headerText,
    text,
    size,
    confirm,
    okButtonText,
    cancelButtonText,
    cancelValue = false,
    markdown = false
  } = props;

  const dispatch = useDispatch();

  const { uiTexts = {} } = useSelector(getTextsData) || {};

  const title = headerText || (confirm ? uiTexts.confirm : uiTexts.notification);

  const handleConfirmClick = useCallback(() => {
    dispatch(UiActions.hideModal(true));
  }, [dispatch]);

  const handleCancelClick = useCallback(() => {
    dispatch(UiActions.hideModal(cancelValue));
  }, [cancelValue, dispatch]);

  const handleModalClose = useCallback((result = false) => {
    dispatch(UiActions.hideModal(result));
  }, [dispatch]);

  return (
    <Modal
      size={size}
      title={title}
      className={Css.appModal}
      contentClassName={Css.contentClassName}
      iconComponent={confirm ? Icons.Question : Icons.Info}
      onClose={handleModalClose}>
      {markdown
        ? (<div
          className={classNames(Css.content, Css.markdown)}
          dangerouslySetInnerHTML={{ __html: purify.sanitize(marked.parse(text || "")) }} />)
        : <div className={Css.content}>{text}</div>}
      <div className={Css.actions}>
        <Button large outline onClick={handleCancelClick}>
          {cancelButtonText || (confirm ? uiTexts.cancel : uiTexts.close)}
        </Button>
        {confirm && (
          <Button large primary onClick={handleConfirmClick}>
            {okButtonText || uiTexts.ok}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default React.memo(AppModal);
